import type { DiscoveredRouteModule } from '@/router/generator/types';

const AdminDesignView = () => import('@/views/admin/DesignView.vue');
export const NAME_ADMIN_DESIGN = 'AdminDesign';
export const PATH_ADMIN_DESIGN = 'design';

export const route: DiscoveredRouteModule = {
  id: 'admin.design',
  scope: 'admin',
  moduleKey: 'design',
  name: NAME_ADMIN_DESIGN,
  path: PATH_ADMIN_DESIGN,
  component: AdminDesignView,
  meta: { requiresAdmin: true, dataLoaders: ['project_document', 'features', 'project_settings', 'project_media'] },
};
